<script setup lang="ts">

import StarRedAnimation from '@/components/Elements/Animations/Star/Types/StarRedAnimation.vue'
import StarBlackAnimation from '@/components/Elements/Animations/Star/Types/StarBlackAnimation.vue'
import StarWhiteAnimation from '@/components/Elements/Animations/Star/Types/StarWhiteAnimation.vue'
import StarOrangeAnimation from '@/components/Elements/Animations/Star/Types/StarOrangeAnimation.vue'
import StarYellowAnimation from '@/components/Elements/Animations/Star/Types/StarYellowAnimation.vue'
import StarBlueLightAnimation from '@/components/Elements/Animations/Star/Types/StarBlueLightAnimation.vue'
import StarBlueDarkAnimation from '@/components/Elements/Animations/Star/Types/StarBlueDarkAnimation.vue'

defineProps({
  type: {
    type: Number,
    required: true,
    validator: (value: number) => {
      return [1, 2, 3, 4, 5, 6, 7, 8, 9, 10].includes(value);
    }
  }
})

/**
 * Sizes
 *
 * Very small: 32
 * Small: 64
 * Medium: 96
 * Large: 128
 * Very large: 160
 *
 */

</script>
<template>
  <template v-if="type == 1">
    <!-- Neutron Star, Invisible, very small -->
    <StarBlackAnimation :size="64"/>
  </template>
  <template v-if="type == 2">
    <!-- White Dwarf, white, small -->
    <StarWhiteAnimation :size="96"/>
  </template>
  <template v-if="type == 3">
    <!-- Red Giant, red, large -->
    <StarRedAnimation :size="160"/>
  </template>
  <template v-if="type == 4">
    <!-- Red Dwarf, red, small -->
    <StarRedAnimation :size="96"/>
  </template>
  <template v-if="type == 5">
    <!-- K Type Star, orange, medium -->
    <StarOrangeAnimation :size="128"/>
  </template>
  <template v-if="type == 6">
    <!-- G Type Star, yellow, medium -->
    <StarYellowAnimation :size="128"/>
  </template>
  <template v-if="type == 7">
    <!-- F Type Star, white, medium -->
    <StarWhiteAnimation :size="128"/>
  </template>
  <template v-if="type == 8">
    <!-- A Type Star, blue, medium -->
    <StarBlueLightAnimation :size="128"/>
  </template>
  <template v-if="type == 9">
    <!-- B Type Star, blue, large -->
    <StarBlueDarkAnimation :size="160"/>
  </template>
  <template v-if="type == 10">
    <!-- O Type Star, blue, very large -->
    <StarBlueLightAnimation :size="192"/>
  </template>


</template>

<style scoped lang="scss">

</style>